export default {
    name: 'SettingsHeader',

    props: {
        title: String
    }
}